import { useContext } from "react";
// provider data
import { PhotoProviderData } from "./Provider";
// interface
import { IPhotoItem } from "./Interface";
// utils
import { getImageUrlWithMaxWidth } from "@src/utils";
// images
import IconPhotos from "@src/assets/images/common/community/icon-photos-gray100@3x.png";
import ImgNotFound from "@src/assets/images/partner/img-notfound@3x.jpg";

const PhotoItem = ({ photoData, idx, type }: IPhotoItem) => {
  // provider data
  const {
    officialPhotoData,
    setSelectedPhoto,
    officialPhotoTotal,
    reviewPhotoTotal,
    selectedFolder,
    setSelectedFolder,
    reviewPhotoData,
  } = useContext(PhotoProviderData).data;

  // 이미지 로딩 에러 핸들러
  const imgErrorHandler = (e: React.ChangeEvent<HTMLImageElement>) => {
    // e.target.closest("li").remove();
    // const target = e.target as HTMLImageElement;
    // target.src = ImgNotFound;
    // console.log(`image error ${e.target.src}`);
  };

  return (
    <li
      className={"photo-item"}
      key={`list-${idx}`}
      onClick={() => {
        // 폴더 사진일 경우(앨범 아이디가 있거나, 메인그룹키가 있으면 폴더 사진으로 처리)
        // if (photoData?.albumId || photoData?.mainGroupKey) {
        if (photoData?.albumId !== null) {
          setSelectedFolder({
            ...selectedFolder,
            id: Date.now(),
            title: photoData.title,
            key: photoData.albumId,
          });
        } else if (
          photoData?.mainGroupKey &&
          photoData?.mainGroupKey !== "representativeImageUrls"
        ) {
          setSelectedFolder({
            ...selectedFolder,
            id: Date.now(),
            key: photoData.mainGroupKey,
            title: photoData.mainGroupKey.replaceAll("amenities", "부대시설"),
          });
        } else {
          // 아닐 경우 모두 사진으로 처리
          setSelectedPhoto({
            id: Date.now(),
            idx: idx,
            photoData: type === "official" ? officialPhotoData : reviewPhotoData,
            total: type === "official" ? officialPhotoTotal : reviewPhotoTotal,
            type: type,
          });
        }
      }}
    >
      <div className="photo-item-inner">
        {/* 앨범 아이디가 있거나, 메인그룹키가 있고 메인그룹키가 representativeImageUrls가 아닐때만 오버레이 및 타이틀 표기 */}
        {(photoData?.albumId ||
          (!!photoData?.mainGroupKey && photoData?.mainGroupKey !== "representativeImageUrls")) && (
          <div className="photo-info">
            <div className="photo-overlay"></div>
            {/* {photoData?.title && <div className="photo-title">{photoData.title}</div>} */}
            {photoData?.albumId ? (
              <div className="photo-title">{photoData.title}</div>
            ) : (
              <div className="photo-title">
                {photoData.mainGroupKey.replaceAll("amenities", "부대시설")}
              </div>
            )}
            {photoData?.albumImageCount && ( // albumImageCount 있을 때만 노출, 해당 파라미터 없는 경우에 노출 필요하다면 조건 추가 필요합니다.
              <div className="photo-count">
                <img
                  src={IconPhotos}
                  alt={`컬렉션 이미지 수 ${photoData.albumImageCount}개`}
                  width={12}
                />
                {photoData.albumImageCount}
              </div>
            )}
          </div>
        )}
        <img
          src={getImageUrlWithMaxWidth(photoData.url, 300)}
          alt={`${type ? type : ""}-photo-${idx}`}
          onError={imgErrorHandler}
          onLoad={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.opacity = "1";
          }}
          loading="lazy"
        />
      </div>
    </li>
  );
};

export default PhotoItem;
